import { ElementType, HTMLAttributes, ReactNode } from "react";
import { twMerge } from 'tailwind-merge'

interface ElementProps extends HTMLAttributes<HTMLDivElement> {
    icon?: ElementType,
    text?: string,
    children: ReactNode
}

export function Element({ icon: Icon, text, children, ...rest }: ElementProps) {
    return (
        <div
            {...rest}
            className={twMerge("tw-bg-white tw-rounded-3xl tw-overflow-hidden tw-shadow-xl", rest.className)}
        >
            {children}
        </div>
    )
}